import React, { useEffect, useState, useRef, useContext } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from '../../../parts/Layout';
import { httpRequest } from '../../../../services/httpService';
import helpers from '../../../../services/helpers';
import Loader from '../../../parts/Loader';
import CategoryFormModal from '../../../modals/CategoryFormModal';
import initTreeView from '../../../../services/initTreeView';
import SchedulesForm from './SchedulesForm';
import ShipsFormModal from '../ships/ShipsFormModal';
import ProfileContext from '../../../../services/profileContext';
import Swal from 'sweetalert2';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { ListBox } from 'primereact/listbox';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import Dropdown from 'react-bootstrap/Dropdown'
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
 
export default function SchedulesList ({viewer = 'admin', home_page = "manage-schedules"}){
    // const {
    //     account
    // } = useContext(ProfileContext);
    const { contact_id } = useParams();
    const toast = useRef(null);
    const navigate = useNavigate(); // Initialize the navigate function
    const [record_data, setRecordData] = useState([]);
    const [loading, setLoading] = useState(1);
    const [search_key, setSearchKey] = useState('');
    const [master_schedule_id, setMasterScheduleID] = useState('');
    const [show_option, setShowOption] = useState(0);
    const [show_schedule, setShowSchedule] = useState(0);
    const [show_ship_modal, setShowShipModal] = useState(0);

    const [data_table, setDataTable] = useState([]);
    const [selected_items, setSelectedItems] = useState([]);
    const [selected_all, setSelectAll] = useState(false);
    const [datatable_state, setDataTableState] = useState({
        first: 0,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null
    });

    const [page_title, setPageTitle] = useState('Voyage Schedules');
    const [menu, setMenu] = useState('manage-schedules');
    const [selected_member_data, setMemberData] = useState('');
    const [selected_member_id, setMemberID] = useState('');
    const [selected_member_index, setMemberIndex] = useState('');
    const [ship_id, setShipID] = useState('');
    const [schedule_id, setScheduleID] = useState('');
    const [schedules, setSchedules] = useState([]);

    const handleEventClick = (clickInfo) => {
        // clickInfo.event contains the FullCalendar event object
        const { id, title, start } = clickInfo.event;
        const { description } = clickInfo.event.extendedProps;

        //setScheduleID(id)
        //setShowOption(true)
        navigate(`/ship-booking/schedules/${id}/manifest`);

        //alert(`Event: ${title}\nDate: ${start.toLocaleDateString()}\nNote: ${description || 'No description'}`);
        
        // You can also trigger modals or navigate to detail pages here
        //console.log("Full Event Data:", clickInfo.event);
    };

    const action_options = [
        { name: 'View Schedule', code: 'edit-schedule' },
        { name: 'Ship Manifest', code: 'manifest' },
    ];

    useEffect(() => {
        initTreeView()
        
        if(contact_id){
            setPageTitle('Customer Owned Master Schedules')
            setMenu('manage-customers')
        }

        fetchDataList({
            "page": datatable_state.page + 1,
            "per_page": datatable_state.rows
        })
    }, []);

    useEffect(() => {
        //displayDataTable(record_data)
    }, [datatable_state.sortOrder]);

    useEffect(() => {
        //displayDataTable(record_data)
    }, [
        selected_items, 
        selected_all
    ]);

    useEffect(() => {
        fetchDataList({
            "page": datatable_state.page + 1,
            "per_page": datatable_state.rows,
            "search": search_key
        })
    }, [datatable_state]);

    function fetchDataList(condition = {
        "page": '',
        "search": '',
        "per_page": ''
    }){
        const page = datatable_state.page
        const per_page = datatable_state.rows
        const search = search_key
        let filter = `?paginate=0&`

        if(page){
            filter += 'page='+page+'&'
        }
        if(per_page){
            filter += 'per_page='+per_page+'&'
        }
        if(search){
            filter += 'search='+search+'&'
        }
        if(contact_id){
            filter += 'customer_id='+contact_id+'&'
        }

        filter = filter.slice(0, -1)

        setLoading(1)

        const url = helpers.createShipBookingHubUrl('voyage'+filter)

        httpRequest(url, "GET", {}, true)
            .then((res) => {
                setSchedules(res)
                //console.log('res', res)
                setLoading(0)
            })
            .catch((err) => {
                //console.log(err)
                setLoading(0)

                Swal.fire({
                    title: "Error!",
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }); 
    }
    
    function search(e){
        let { value } = e.target;
        setSearchKey(value)
        fetchDataList({
            "page": datatable_state.page + 1,
            "search": value
        })
    }

    function triggerAction(data = '', action = '', status = ''){
        let ids = [];
        if(action === 'single-delete'){
            ids.push(data.id)
        }
        else{
            ids = data.map(o => o['id']);
        }

        let title = 'Delete Master Schedule'
        if(ids.length > 1){
            title = 'Delete Categories'
        }

        Swal.fire({
            title: title,
            text: 'This action cannot be reversed. All associated records will also be deleted. Do you want to continue?',
            showCancelButton: true,
            showConfirmButton: false,
            closeOnCancel: true,
            showDenyButton: true,
            denyButtonText: 'Yes'
        })
        .then((result) => {
            if (result.isDenied) {
                deleteItem(ids)
            }
        })
    }

    function deleteItem(id){
        const url = helpers.createShipBookingHubUrl('master-schedules/delete')
        httpRequest(url, 'POST', {
            postdata: {
                "ids": id
            },
        }, true)
            .then((res) => {
                setLoading(0)
                fetchDataList({
                    "page": datatable_state.page + 1,
                    "per_page": datatable_state.rows,
                    "search": search_key
                })
                setSelectedItems([])

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                setSelectedItems([])

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    function formatDuration(duration_minutes){
        const hours = Math.floor(duration_minutes / 60);
        const mins = duration_minutes % 60;
        
        // Returns format: "2h 10m"
        return `${hours}h ${mins}m`;
    }

    function addMinutesAndFormat(startTime, durationMinutes) {
        // 1. Parse the "19:00:00" string
        const [hours, minutes, seconds] = startTime.split(':');
        const date = new Date();
        date.setHours(hours, minutes, seconds);

        // 2. Add the duration
        date.setMinutes(date.getMinutes() + parseInt(durationMinutes));

        // 3. Format to "07:00PM"
        return new Intl.DateTimeFormat('en-US', {
            hour: '2-digit',   // Ensures leading zero (e.g., "03")
            minute: '2-digit', // Ensures minutes are shown (e.g., ":00")
            hour12: true       // Uses AM/PM
        }).format(date).replace(/\s+/g, ''); // Removes the space before AM/PM
    }

    function getActiveDays(schedule) {
        const dayKeys = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
        
        return dayKeys
            .filter(day => schedule[day] === 1) // Check if the day is set to 1
            .map(day => day.toUpperCase())     // Convert to MON, WED, etc.
            .join(', ');                        // Combine into one string
    }

    const onPage = (e) => {
        setDataTableState(e)
        setSelectedItems([])
    };

    const onSelectItem = (e) => {
        const value = e.value;
        setSelectedItems(value);
    };

    function displayActionMenu(data){
        return (<Dropdown>
                        <Dropdown.Toggle className='btn-light border' size="sm" id={"dropdown-actions-"+data.id}>Action</Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                            <Dropdown.Item key="edit" onClick={(e) => editForm(data.id)}><i className="fas fa-pencil-alt mr-2" />Edit</Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item key="delete" className='text-danger' onClick={(e) => triggerAction(data, 'single-delete')}><i className="fas fa-trash mr-2" />Delete</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>)
    }
    
    function addForm(e){
        setMasterScheduleID('')
        setShowOption(1)
    }
    function editForm(id){
        setShowOption(1)
        setMasterScheduleID(id)
    }

    function handleSave(){
        fetchDataList()
    }

    function handleShipSave(){
        fetchDataList()
    }

    function handleOptionSelection(e){
        const {
            code
        } = e.value
        console.log('code', code)

        if(code === 'edit-schedule'){
            setShowSchedule(true)
        }
        else{
            window.open(`/ship-booking/schedules/${schedule_id}/manifest`, "_blank", "noopener,noreferrer");
            //toast.current.show({severity:'success', detail: 'The generated manifest has been opened in another tab.', life: 20000});
        }
        setShowOption(false)
    }

    return (
        <>
        <Toast ref={toast} position="top-right" />
        
        <SchedulesForm 
            is_show={show_schedule} 
            setShow={setShowSchedule} 
            handleSave={handleSave} 
            reference_id={schedule_id}
            customer_id={contact_id}
        />

        <Dialog 
            visible={show_option} 
            position="center" 
            header="Choose Action" 
            style={{ width: '25vw' }} // Adjust width here for "small" feel
            breakpoints={{ '960px': '75vw', '641px': '90vw' }} // Responsive widths
            onHide={setShowOption} 
        >
            <ListBox 
                //value={selectedItem} 
                onChange={(e) => handleOptionSelection(e)} 
                options={action_options} 
                optionLabel="name" 
                className="w-full" 
                listStyle={{ maxHeight: '200px' }} // Keeps the dialog small
            />
        </Dialog>
        
        <Layout page_title={page_title} menu={menu}>

            <div className="container-fluid" style={{position: 'relative'}}>
                <Loader isLoading={loading}/>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <FullCalendar
                                    plugins={[dayGridPlugin]}
                                    initialView="dayGridMonth"
                                    weekends={true}
                                    events={schedules}
                                    eventClick={handleEventClick} // The 'onclick' handler
                                    // Optional Styling
                                    // eventColor="#3788d8"
                                    height="auto"
                                    eventTimeFormat={{
                                        hour: 'numeric',
                                        minute: '2-digit',
                                        meridiem: 'short', // or 'narrow' for just 'p'
                                        omitZeroMinute: true // Turns 8:00PM into 8PM
                                    }}
                                    dayMaxEvents={true}
                                    displayEventEnd={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
        </>
    )
}